"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
var Connection = /** @class */ (function () {
    function Connection(url, options, logger) {
        var _this = this;
        this.failedRetriesCount = 0;
        this.lastRetryInterval = 0;
        this.currentStatus = types_1.ConnectionStatus.Disconnected;
        this.ondrop = null;
        this.oneventmessage = null;
        this.ondown = null;
        this.onreopen = null;
        this.handleMessage = function (event) {
            var _a, _b;
            var message = JSON.parse(event.data);
            if (message.type === "connected") {
                var previousStatus = _this.status;
                _this.setStatus(types_1.ConnectionStatus.Connected);
                if (previousStatus === types_1.ConnectionStatus.Connecting) {
                    _this.resetReconnectInfo();
                    _this.connectResolve(message.connectionId);
                }
                else if (previousStatus === types_1.ConnectionStatus.DisconnectedRetrying) {
                    _this.resetReconnectInfo();
                    (_a = _this.onreopen) === null || _a === void 0 ? void 0 : _a.call(_this);
                }
            }
            (_b = _this.oneventmessage) === null || _b === void 0 ? void 0 : _b.call(_this, message);
        };
        this.handleClose = function (closeEvent) {
            var _a, _b;
            var error = new Error(JSON.stringify({
                errorCode: closeEvent.code,
                reason: closeEvent.reason,
            }));
            if (_this.status === types_1.ConnectionStatus.Connecting ||
                _this.status === types_1.ConnectionStatus.DisconnectedRetrying) {
                _this.failedRetriesCount += 1;
                if (_this.failedRetriesCount >= _this.options.maxReconnectAttempts ||
                    closeEvent.code >= 4000) {
                    _this.logger("error", "Connection: Failed to reconnect after " + _this.failedRetriesCount + " with error code " + closeEvent.code);
                    if (_this.status === types_1.ConnectionStatus.Connecting) {
                        _this.connectReject(error);
                    }
                    else {
                        (_a = _this.ondrop) === null || _a === void 0 ? void 0 : _a.call(_this);
                    }
                    _this.disconnect();
                    return;
                }
                _this.logger("warning", "Connection: Failed to reconnect, attempt " + _this.failedRetriesCount);
            }
            else {
                _this.logger("warning", "Connection: Connection lost. Retrying to connect");
                _this.setStatus(types_1.ConnectionStatus.DisconnectedRetrying);
                (_b = _this.ondown) === null || _b === void 0 ? void 0 : _b.call(_this, error);
            }
            _this.scheduleReconnect();
        };
        this.reconnect = function () {
            _this.logger("info", "Trying to reconnect...");
            _this.destroyWebSocket();
            _this.createWebSocket();
        };
        this.url = url;
        this.options = __assign(__assign({}, Connection.DefaultOptions), options);
        this.logger = logger !== null && logger !== void 0 ? logger : (function () { });
    }
    Connection.prototype.connect = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        if (_this.status !== types_1.ConnectionStatus.Disconnected) {
                            reject(new Error("You can trigger a connect only when disconnected"));
                            return;
                        }
                        _this.setStatus(types_1.ConnectionStatus.Connecting);
                        _this.connectResolve = resolve;
                        _this.connectReject = reject;
                        _this.createWebSocket();
                    })];
            });
        });
    };
    Connection.prototype.disconnect = function () {
        clearTimeout(this.reconnectTimeout);
        this.resetReconnectInfo();
        this.destroyWebSocket();
        this.setStatus(types_1.ConnectionStatus.Disconnected);
    };
    Object.defineProperty(Connection.prototype, "status", {
        get: function () {
            return this.currentStatus;
        },
        enumerable: false,
        configurable: true
    });
    Connection.prototype.publish = function (event) {
        var _a;
        if (this.status !== types_1.ConnectionStatus.Connected) {
            throw new Error("publish is allowed only when connected");
        }
        (_a = this.webSocket) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify(event));
    };
    Connection.prototype.setStatus = function (status) {
        this.currentStatus = status;
    };
    Connection.prototype.createWebSocket = function () {
        try {
            this.webSocket = new WebSocket(this.url);
            this.webSocket.addEventListener("close", this.handleClose);
            this.webSocket.addEventListener("message", this.handleMessage);
        }
        catch (ex) {
            this.logger("error", "Connection: Failed to open web socket");
            throw ex;
        }
    };
    Connection.prototype.destroyWebSocket = function () {
        if (!this.webSocket) {
            return;
        }
        this.webSocket.removeEventListener("close", this.handleClose);
        this.webSocket.removeEventListener("message", this.handleMessage);
        this.webSocket.close();
        this.webSocket = undefined;
    };
    Connection.prototype.scheduleReconnect = function () {
        var interval = this.retryInterval();
        this.reconnectTimeout = setTimeout(this.reconnect, interval);
        this.lastRetryInterval = interval;
    };
    Connection.prototype.retryInterval = function () {
        var _a = this.options, minReconnectDelay = _a.minReconnectDelay, maxReconnectDelay = _a.maxReconnectDelay, reconnectBackoffFactor = _a.reconnectBackoffFactor;
        return Math.max(minReconnectDelay, Math.min(this.lastRetryInterval * reconnectBackoffFactor, maxReconnectDelay));
    };
    Connection.prototype.resetReconnectInfo = function () {
        this.failedRetriesCount = 0;
        this.lastRetryInterval = 0;
    };
    Connection.DefaultOptions = {
        minReconnectDelay: 1000,
        maxReconnectDelay: 30000,
        maxReconnectAttempts: Number.POSITIVE_INFINITY,
        reconnectBackoffFactor: 1.5,
    };
    return Connection;
}());
exports.default = Connection;
//# sourceMappingURL=connection.js.map